export default __webpack_public_path__ + "static/media/file-download.cbd8bdbb.svg";